import { useState } from 'react';

const Logo = ({ variant = 'light', className = '', size = 'default' }) => {
  const [imageError, setImageError] = useState(false);
  
  const logoSrc = variant === 'dark' ? '/logos/logo-white.png' : '/logos/logo-light-bg.png';
  
  const sizeClasses = {
    xsmall: 'h-5 sm:h-6',
    small: 'h-6 sm:h-7',
    default: 'h-8 sm:h-10',
    large: 'h-12 sm:h-14'
  };
  
  if (imageError) {
    // Fallback to text if logo fails to load
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <svg className="h-6 w-6 text-[var(--brand-ocean-700)]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" fill="currentColor" />
        </svg>
        <span className="font-heading font-bold text-lg text-[var(--brand-ocean-700)]">Snap Windows</span>
      </div>
    );
  }
  
  return (
    <img
      src={logoSrc}
      alt="Snap Windows Logo"
      className={`${sizeClasses[size]} w-auto object-contain ${className}`}
      onError={() => setImageError(true)}
    />
  );
};

export default Logo;
